import processLocale from '@lib/locale'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const yotpoInstanceIds = {
  en: '1224279',
  'en-au': '1224279',
  'en-us': '1224298',
  'en-nz': '1224299',
  'en-ca': '1224301',
  'en-gb': '1224300',
}

const YotpoGlobalReviews = () => {
  const { locale } = useRouter()

  useEffect(() => {
    try {
      window.yotpoWidgetsContainer?.initWidgets()
    } catch (error) {}
  }, [locale])
  const currentLocale = processLocale(locale) as keyof typeof yotpoInstanceIds
  const yotpoInstanceId = yotpoInstanceIds[currentLocale] || yotpoInstanceIds['en']
  if (!yotpoInstanceId) return null

  return <div className="yotpo-widget-instance" data-yotpo-instance-id={yotpoInstanceId} />
}

export default YotpoGlobalReviews
